
class SmartfitHandlerClass {

	loaded = false;

	lastButton = null;

	constructor() {

		// Consent Handling - Load SmartFit, when the consent was given.
		window.addEventListener( 'UC_GENERAL', ( ev ) => {
			if ( ev.detail && ( ev.detail.SmartFit || ! ( 'SmartFit' in ev.detail ) ) ) {
				this.loadScript();
			}
		} );

		// When we reload the product - we reinitialise our buttons.
		document.addEventListener( 'finished_change_variant', () => this.reinitialise() );

		// Automatically open the SmartFit Popup after consent confirmation.
		document.addEventListener( 'click', ( ev ) => {
			// Click on the SmartFit Button without JS.
			if ( ev.target.matches( '[data-oz-embed]' ) && ev.target.matches( '.en_js_open_popup' ) ) {
				this.lastButton = ev.target;
			}

			// Click on the confirm button in the popup.
			if ( ev.target.matches( '.js-usercentrics-accept-smartfit' ) ) {
				const buttonEl = this.lastButton;
				if ( buttonEl ) {
					// Trigger the button as soon as the sizing is available.
					document.addEventListener( 'ozSizingAvailable', () => {
						setTimeout( () => buttonEl.click(), 100 );
					}, { once: true });
				}
			}
		} );
	}

	hasButton() {
		return !! document.querySelector( '[data-oz-embed]' );
	}
	hasConsent() {

		if ( window.UC_UI ) {
			const service = window.UC_UI.getServicesBaseInfo().find( ({name}) => 'SmartFit' === name );
			if ( service && 'consent' in service ) {
				return service.consent.status;
			}
		}

		return true;
	}

	getConfig() {

		const selectSizeInShop = (payload) => {

			const { code } = payload;
			const size = window.OZ_EanData[ code ]?.size || null;

			const buttonEl = document.getElementById( payload.id );
			const detailsEl = buttonEl.closest( '#details_container' );
			const VariantHandler = detailsEl.ACL_Article_Variant;

			// Change to correct size, if necessary.
			VariantHandler.setSize( size ).then( () => {
				// Add to Basket.
				detailsEl.querySelector( '.to_cart' ).click();
			});
		};

		const showButton = ( payload ) => {
			const buttonEl = document.getElementById( payload.id );
			buttonEl.classList.remove( 'en_js_open_popup' );
			buttonEl.removeAttribute( 'data-en-popup-target' );
			buttonEl.parentElement.classList.remove( 'en_hidden' );

			document.dispatchEvent( new CustomEvent( 'ozSizingAvailable' ) );
		};

		const hideButton = ( payload ) => {
			const buttonEl = document.getElementById( payload.id );
			buttonEl.parentElement.classList.add( 'en_hidden' );
		};

		const checkStock = ( payload ) => {
			const { code } = payload;
			const stockStatus = window.OZ_EanData[ code ]?.stock || 0;

			let sizeAvailable = false;
			if ( stockStatus > 0 ){
				sizeAvailable = true;
			}

			return sizeAvailable;
		}

		return {
			settings: {
				apiKey: "$oz_$NAd.CFbDG08bJBDcQpPcnOVLVc3XiU5JmacsK0qb52Qj6yt2gz3Ta",
				language: "de",
				primary: '#ef820f',
				cta: '#ef820f',
				roundness: '0'
			},
			events: {
				confirmSize: {
					callback: selectSizeInShop
				},
				sizingAvailable: {
					callback: showButton,
				},
				sizingUnavailable: {
					callback: hideButton
				},
				checkIsAvailable: {
					callback: checkStock
				},
				// confirmSizeDoesNotFit: {
				// 	callback: showAlternatives,
				// },
				// confirmSizeUnavailable: {
				// 	callback: showAlternatives
				// }
			}
		};
	}

	loadScript() {

		// Only load this once per pageload.
		if ( this.loaded ) {
			return;
		}

		// Check for Button and Consent. If neither is given, we don't need to load.
		if ( ! this.hasButton() || ! this.hasConsent() ) {
			return;
		}

		this.loaded = true;

		((win, doc, script, key, config, src) => {
			win["___OnlineSizing"] = key;
			win["___OnlineSizingConfig"] = config;
			const js = doc.createElement(script);
			js.id = key;
			js.src = src;
			js.async = true;
			const scripts = doc.getElementsByTagName(script);
			const lastScript = scripts[scripts.length - 1];
			lastScript.parentNode.insertBefore(js, lastScript);
		})(
			window,
			document,
			"script",
			"oz",
			this.getConfig(),
			`https://widgets.onlinesizing.bike/loader.js`
		);
	}

	reinitialise() {
		// Reload all widgets, if enabled.
		const OZ_Widget = window.oz;
		if ( OZ_Widget ) {
			OZ_Widget.destroy();
			OZ_Widget.initialize();
		}
	}
}

const SmartfitHandler = new SmartfitHandlerClass();
export default SmartfitHandler;
